/**
 * Tymes4 Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AccountingExportRowType = 1 | 2 | 3;

export const AccountingExportRowType = {
    Payment: 1 as AccountingExportRowType,
    CustomerCredit: 2 as AccountingExportRowType,
    Invoice: 3 as AccountingExportRowType
};

